import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const menuSearchSchema = z.object({
  openCategoryTab: z.boolean().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/menu/')({
  validateSearch: menuSearchSchema,
})
